module.exports = __webpack_public_path__ + "img/issue-icon15.0a5df32.png";